module.exports = __webpack_public_path__ + "img/home-4.eaa2caee.webp";